export const GET_ACTIVITY_LOG_BY_APPOINTMENT_ID = '/activities/';
export const GET_ACTIVITY_LOGS = (queryParams: string = '') => '/activities/' + queryParams;
